import Sentry from "@similarweb/sentry-logger";
import swLog from "@similarweb/sw-log";

import { swSettings } from "app/common/services/swSettings";
import { DefaultFetchService } from "app/services/fetchService";

const AVAILABLE_ALLOCATIONS_URL = "api/homepage/invitations/account-has-available-allocations";

const fetchService = DefaultFetchService.getInstance();

let hasAvailableAllocations: boolean | null = null;

interface IHasAvailableAllocationsResponse {
    hasAvailableAllocations: boolean;
}
const availableAllocationsRequest = async (): Promise<boolean> => {
    if (swSettings.components.Home.resources.AllowUnlimitedSeatsInvitations) {
        try {
            const response: IHasAvailableAllocationsResponse = await fetchService.get(AVAILABLE_ALLOCATIONS_URL);
            return response.hasAvailableAllocations;
        } catch (error) {
            const logMsg = `[JOURNEY] - HomePage - availableAllocationsRequest Promise failed - ${error}`;
            swLog.serverLogger(logMsg, error, "Error");
            Sentry.error(logMsg, error);

            return false;
        }
    }

    return false;
};

export const getHasAvailableAllocations = async (): Promise<boolean> => {
    if (hasAvailableAllocations === null) {
        hasAvailableAllocations = await availableAllocationsRequest();
    }
    return hasAvailableAllocations;
};
